var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('webix-ui',{attrs:{"config":_vm.ui},model:{value:(_vm.all_products),callback:function ($$v) {_vm.all_products=$$v},expression:"all_products"}}),_c('div',{attrs:{"id":"productsPaging"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }